export const getPoiFilterValues = (value) => ({
  type: 'POI_FILTER_VALUES',
  payload: value,
});
export const resetFilterValueTOFirstLoad = (value) => ({
  type: 'RESET_FILTER_VALUE_TO_FIRST_LOAD',
});


export const resetPoiFilterValues = () => ({
  type: 'RESET_POI_FILTER_VALUES',
});